export default __webpack_public_path__ + "static/SRUS OC234 - Especification Del Producto y Datos Técnicos-4ce7e2f5ffe3371f8c9bae9ecebc4e0a.pdf";